import axios from "axios";

const apiFinancial = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_FINANCIAL_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8086",
});

export default apiFinancial;
